/**
 * Bootstrap locks page scroll while a modal is open by adding the `modal-open`
 * class plus inline `overflow`/`padding-right` to <body> and a `.modal-backdrop`
 * node. When a modal is unmounted before Bootstrap's async hide transition
 * finishes (e.g. close + redirect), that cleanup never runs and <body> stays
 * locked across navigations. Call this to restore scroll deterministically.
 *
 * Guarded against stacked modals: while another modal is still open (e.g. an
 * equipment modal opened on top of a work-order modal), the lock and backdrops
 * are left intact so the remaining modal keeps its scroll lock.
 */
export const restoreBodyScroll = (): void => {
  const hasOpenModal = document.querySelectorAll(".modal.show").length > 0;
  if (hasOpenModal) return;

  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
  document.querySelectorAll(".modal-backdrop").forEach((element) => element.remove());
};
